import React, { forwardRef } from "react"
import styled from "styled-components"

const TwoViewSVG = forwardRef((props, ref) => {
  return (
    <SVGWrapper ref={ref} width={props.width || 200} color={props.color} version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">
      <title>New Project</title>
      <path id="Shape 6" className="s0" d="m0 0h400v225h-400z" />
      <path id="Shape 3" className="s1" d="m204.8 14c0-1.7 1.3-3 3-3h165.6c1.6 0 3 1.3 3 3v91c0 1.7-1.4 3-3 3h-165.6c-1.7 0-3-1.3-3-3z" />
      <path id="Shape 3 copy" className="s1" d="m22.6 14c0-1.7 1.4-3 3-3h165.6c1.7 0 3 1.3 3 3v91c0 1.7-1.3 3-3 3h-165.6c-1.6 0-3-1.3-3-3z" />
      <path id="Shape 4" className="s1 browser-source" d="m229 120c0-1.7 1.3-3 3-3h150c1.7 0 3 1.3 3 3v85c0 1.7-1.3 3-3 3h-150c-1.7 0-3-1.3-3-3z" />
      <path id="Shape 5" className="s2" d="m235.2 128.7v-5h143.9v5z" />
      <path id="Shape 5 copy" className="s2" d="m235.2 137.7v-5h143.9v5z" />
      <path id="Shape 5 copy 2" className="s2" d="m235.2 146.7v-5h143.9v5z" />
      <path id="Shape 5 copy 3" className="s2" d="m235.2 157.7v-5h143.9v5z" />
      <path id="Shape 5 copy 4" className="s2" d="m235.2 167.7v-5h143.9v5z" />
      <path id="Shape 5 copy 5" className="s2" d="m235.2 177.7v-5h143.9v5z" />
      <path id="Shape 5 copy 6" className="s2" d="m235.2 187.7v-5h143.9v5z" />
      <path id="Shape 5 copy 7" className="s2" d="m235.2 197.7v-5h143.9v5z" />
    </SVGWrapper>
  )
})

export default TwoViewSVG

const SVGWrapper = styled.svg`
  --color: ${props => props.color || '#fff'};
  .s0 { fill: none;stroke: var(--color);stroke-width: 10 }
  .s1 { fill: none;stroke: var(--color);stroke-width: 5 }
  .s2 { fill: var(--color);stroke: var(--color);stroke-width: 0.1 }

  .browser-source {
    stroke: var(--green-text);
    fill: var(--green-selected);
  }
`
